import { useQuery } from '@tanstack/react-query'
import ms from 'ms'

import HttpClient from '@utils/HttpClient'

import type { components } from '@/schema'

export type WorkflowResponse = components['schemas']['WorkflowResponse']
export type WorkflowJobResponse = components['schemas']['WorkflowJobResponse']

const workflowKeys = {
  all: ['workflows'] as const,
  range: (from?: string, to?: string) => ['workflows', { from, to }] as const,
}

interface WorkflowQueryParams {
  from?: string
  to?: string
}

export function useRunningWorkflows(params?: WorkflowQueryParams) {
  return useQuery({
    queryKey: params ? workflowKeys.range(params.from, params.to) : workflowKeys.all,
    queryFn: async () => {
      const queryParams = new URLSearchParams()
      if (params?.from) queryParams.append('from', params.from)
      if (params?.to) queryParams.append('to', params.to)

      const queryString = queryParams.toString()
      const url = `/api/workflow${queryString ? `?${queryString}` : ''}`

      return HttpClient.get<WorkflowResponse[]>(url)
    },
    refetchInterval: (query) => {
      const hasRunningWorkflows = query.state.data?.some(
        (workflow) => workflow.status === 'RUNNING'
      )
      const hasRunningJobs = query.state.data?.some(
        (workflow) => workflow.jobs.some(job => job.status === 'RUNNING')
      )

      return hasRunningWorkflows || hasRunningJobs ? ms('1s') : ms('1m')
    },
  })
}